import { render, staticRenderFns } from "./PurchaseRequest.vue?vue&type=template&id=a39e286e"
import script from "./PurchaseRequest.vue?vue&type=script&lang=js"
export * from "./PurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports